import React from 'react'

import Link from 'components/CommonUI/Link/Link'
import DropdownMenu from 'components/CommonUI/Dropdown'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { routingConstants } from '../../constants/routingConstants'

const ControlFacilityItem = (props) => {
  const { onClick, facilityName, isActive } = props
  return (
    <button
      className={`facility_item_button ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <span className="facility_item_text">{facilityName}</span>
      <ArrowForwardIosIcon className="facility-icon" />
    </button>
  )
}

const FacilityItem = ({ pathname, facilityName, facilityId, isActive }) => {
  return (
    <DropdownMenu
      controlComponent={(props) => (
        <ControlFacilityItem
          {...props}
          facilityName={facilityName}
          facilityId={facilityId}
          isActive={isActive}
        />
      )}
      controlProps={{ pathname }}
      classNameContainer={'facility-item-container'}
      label
      styleMenu={{
        left: '100%',
        bottom: '-20%',
        top: 'unset',
        right: 'unset',
        minWidth: 'unset',
        marginBottom: '10px',
      }}
    >
      <DropdownMenu.Item facilityId={facilityId}>
        <Link
          className="facility-item"
          to={`${routingConstants.facility}/${facilityId}`}
        >
          Dashboard
        </Link>
      </DropdownMenu.Item>
      <DropdownMenu.Item>
        <Link
          className="facility-item"
          to={`${routingConstants.equipment}/${facilityId}`}
        >
          Equipment
        </Link>
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}

export default FacilityItem
